//
import Model from '@/models/Model'
import InvoiceNumberModel from '@/models/Actions/AInvoiceNumber'

/**
 *
 */
export default class PchPurchaseOrderInvoiceNum extends Model {
    //
    static includes = [
        'pch_detail_purchase_order_has_invoice_numbers.wh_product',
        'pch_detail_purchase_order_has_invoice_numbers.wh_product_service',
    ]

    /**
     * @description
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    changeInvoiceNumber() {
        return this.hasMany(InvoiceNumberModel)
    }

    /**
     * @description
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    invoiceNumber() {
        return this.hasMany(InvoiceNumberModel)
    }

    /**
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    deleteInvoiceNumber() {
        return this.$http.request({
            method: 'delete',
            url: this.fullURL().concat('/invoice_number'),
        })
    }

    /**
     *
     */
    get selected() {
        return this.pch_detail_purchase_order_has_invoice_numbers.map(
            this.mapSelected
        )
    }

    /**
     *
     */
    mapDetail = item => ({
        quantity: Number(item.quantity),
        net_price: Number(item.net_price),
        global_discount_line_amount: Math.ceil(item.global_discount_line_amount) * 1,
        global_discount_line_percentage: Number(item.global_discount_line_percentage),
        wh_product_id: Number(item.wh_product_id),
        wh_product_service_id: item.wh_product_service_id ? Number(item.wh_product_service_id) : null,
    })

    /**
     *
     */
    mapSelected = item => ({
        id: Number(item.wh_product_service ? item.wh_product_service.id : item.wh_product.id),
        internal_code: String(item.wh_product.internal_code),
        name: String(item.wh_product_service ? item.wh_product_service.name : item.wh_product.name),
        quantity: Number(item.quantity),
        net_price: Number(item.net_price),
        /*global_discount_line_percentage: 
            Number((Number(item.global_discount_line_amount) / (Number(item.net_price) * Number(item.quantity)) * -100 || 0).toFixed(2)),*/
        /*global_discount_line_percentage: 
            Number(item.global_discount_line_amount) / (Number(item.net_price) * Number(item.quantity)) * 100 || 0,*/
        //global_discount_line_percentage: 0,
        global_discount_line_percentage: Number(item.global_discount_line_percentage),
        global_discount_line_amount: Number(item.global_discount_line_amount),
        net_total: Number(item.net_total),
        wh_product_id: Number(item.wh_product_id),
        wh_product_service_id: item.wh_product_service_id ? Number(item.wh_product_service_id) : null,
    })

    /**
     * Parsing the global discount line percentage to rounded amount.
     *
     * @param      {<type>}  item    The item
     * @return     {<type>}  { description_of_the_return_value }
     */
    parseGlobalDiscountLineAmount(item) {

        //
        const netPrice = Number(item.net_price)
        const globalPercentage = Number(item.global_discount_line_percentage)
        const globalAmount = netPrice * globalPercentage / -100
        const globalRound =  Math.round(globalAmount)

        //
        return globalRound
    }

    /**
     *
     */
    resource() {
        return 'pch_purchase_order_invoice_num'
    }

    /**
     * @description
     * Returns a change invoice number representation of the object.
     *
     * @return  {<type>}    Change invoice number representation of the object.
     */
    toChangeInvoiceNumber() {
        return this.clean([
            'invoice_number',
        ])
    }

    /**
     *
     */
    toUpdate() {
        //
        this.details = this.pch_detail_purchase_order_has_invoice_numbers.map(
            this.mapDetail
        )
        //
        return this.clean(['details', 'id'])
    }
}
